export default "__VITE_ASSET__1PnXDeTn__"